import React, { useState } from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
    CircularProgress,
    Button,
    Divider,
    Grid,
    useMediaQuery,
    useTheme
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Greeting from "../Layout/Greeting";
import { ExpandMore, ExpandMoreSharp, ExpandOutlined } from "@mui/icons-material";

// Simulated async fetch function
const fetchBillingDetails = (id) =>
    new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                diagnosis: "Respiratory Infection",
                date: "December 12, 2020",
                amount: "₦72,680.00",
                hmoCover: "₦72,680.00",
                balance: "₦0.00",
                items: [
                    { name: "Venipuncture Microscopy Scan", cost: "₦12,000.00" },
                    { name: "Urine Analysis Microscopy", cost: "₦9,000.00" },
                    { name: "Thyroidic Test", cost: "₦6,000.00" },
                    { name: "Complete Electrocardiogram", cost: "₦10,000.00" },
                    { name: "Paracetamol 500mg", cost: "₦700.00" },
                    { name: "Brain Scan", cost: "₦35,000.00" }
                ]
            });
        }, 1200);
    });

const billingRecords = [
    { id: 1, title: "Ear Infection", amount: "₦8,562.00" },
    { id: 2, title: "Milk Allergy Treatment", amount: "₦4,980.00" },
    { id: 3, title: "Skin Infection Treatment", amount: "₦25,734.00" }
];

const BillingHistory = () => {
    const [expanded, setExpanded] = useState(null);
    const [loadingId, setLoadingId] = useState(null);
    const [details, setDetails] = useState({});
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const handleAccordionToggle = async (panelId) => {
        const isOpening = expanded !== panelId;
        if (isOpening && !details[panelId]) {
            setLoadingId(panelId);
            const data = await fetchBillingDetails(panelId);
            setDetails((prev) => ({ ...prev, [panelId]: data }));
            setLoadingId(null);
        }
        setExpanded(isOpening ? panelId : null);
    };

    return (
        <Box p={isMobile ? 2 : 4}>
            <Greeting name={sessionStorage.getItem("name")} />

            <Typography variant="h6" mt={2} fontWeight={600}>
                Billing History
            </Typography>
            <Typography color="text.secondary" mb={3} fontSize="14px">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus, nulla a accumsan at morbi bibendum tortor id a.
            </Typography>

            {billingRecords.map((record) => (
                <Accordion
                    key={record.id}
                    expanded={expanded === record.id}
                    onChange={() => handleAccordionToggle(record.id)}
                    sx={{
                        mb: 1,
                        border: expanded === record.id ? "1px solid #34C759" : "1px solid #e0e0e0",
                        // bgcolor: expanded === record.id ? "#eafff0" : "#fafafa",
                        borderRadius: "10px"
                    }}
                >
                    <AccordionSummary sx={{
                        bgcolor: "#eafff0",
                        borderBottom: expanded === record.id ? "1px solid #34C759" : ""
                    }} expandIcon={<ExpandMoreSharp />}>
                        <Box display="flex" justifyContent="space-between" width="100%">
                            <Typography fontWeight={600}>{details[record.id]?.diagnosis || record.title}</Typography>
                            <Typography fontWeight={600}>{details[record.id]?.amount || record.amount}</Typography>
                        </Box>
                    </AccordionSummary>

                    <AccordionDetails>
                        {loadingId === record.id ? (
                            <Box textAlign="center" py={2}>
                                <CircularProgress size={24} />
                            </Box>
                        ) : (
                            details[record.id] && (
                                <Box>
                                    <Grid container spacing={1}>
                                        {/* Header Row */}
                                        <Grid item xs={12}>
                                            <Box display="flex" justifyContent="space-between">
                                                <Typography fontWeight={600}>Items</Typography>
                                                <Typography fontWeight={600}>Cost</Typography>
                                            </Box>
                                        </Grid>

                                        {/* Item Rows */}
                                        {details[record.id].items.map((item, idx) => (
                                            <Grid item xs={12} key={idx}>
                                                <Box display="flex" justifyContent="space-between">
                                                    <Typography fontSize="14px">
                                                        {idx + 1}. {item.name}
                                                    </Typography>
                                                    <Typography fontSize="14px">{item.cost}</Typography>
                                                </Box>
                                            </Grid>
                                        ))}
                                    </Grid>

                                    <Divider sx={{ my: 2 }} />

                                    <Box mt={2}>
                                        {/* Total Bill */}
                                        <Box display="flex" justifyContent="space-between">
                                            <Typography fontWeight={600}>Total Bill</Typography>
                                            <Typography fontWeight={600}>{details[record.id].amount}</Typography>
                                        </Box>

                                        {/* HMO Cover */}
                                        <Box display="flex" justifyContent="space-between" mt={1}>
                                            <Typography>HMO Cover</Typography>
                                            <Typography>{details[record.id].hmoCover}</Typography>
                                        </Box>

                                        {/* Balance */}
                                        <Box display="flex" justifyContent="space-between" mt={1}>
                                            <Typography>Balance (Patient’s payment)</Typography>
                                            <Typography>{details[record.id].balance}</Typography>
                                        </Box>
                                    </Box>

                                    <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <CalendarTodayIcon sx={{ fontSize: 16 }} />
                                            <Typography fontSize="13px">{details[record.id].date}</Typography>
                                        </Box>
                                        <Button size="small" variant="contained" color="success">
                                            View Treatment Details
                                        </Button>
                                    </Box>
                                </Box>
                            )
                        )}
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    );
};

export default BillingHistory;
